import { W, H, PITCH, DIST, SCALE, CX, CY, YAW, YAW_PERIOD, clamp, smooth } from "./scene";

/*
  Draws one frame of the bonsai at time t (seconds since it started growing).
  Each dot fades in and, for foliage, slides out from the centre of its pad.
  The view swings back and forth like the homepage figure; dots on the trunk,
  limbs and pad edges fade out as they turn away from the camera during the
  swing, and fade back in as they turn toward it. Once grown, only the outer foliage changes size and brightness.
  `still` draws the finished tree, face on, with no movement.
*/

function project(x, y, z, yaw) {
  const x1 = x * Math.cos(yaw) - z * Math.sin(yaw), z1 = x * Math.sin(yaw) + z * Math.cos(yaw);
  const y2 = y * Math.cos(PITCH) + z1 * Math.sin(PITCH), z2 = z1 * Math.cos(PITCH) - y * Math.sin(PITCH);
  const f = DIST / (DIST + z2);
  return [CX + x1 * f * SCALE, CY - y2 * f * SCALE, f];
}

export function paintFrame(ctx, scene, t, ink, still) {
  ctx.clearRect(0, 0, W, H);
  const yaw = still ? 0 : YAW * Math.sin((2 * Math.PI * t) / YAW_PERIOD);
  // Direction from a surface to the camera, in world space, for this yaw
  const vx = -Math.cos(PITCH) * Math.sin(yaw), vy = Math.sin(PITCH), vz = -Math.cos(PITCH) * Math.cos(yaw);
  ctx.fillStyle = ink;
  for (let i = 0; i < scene.dots.length; i++) {
    const d = scene.dots[i], p = (t - d.b) / d.d;
    if (p <= 0) continue;
    // Surfaces turning away from the camera fade out gradually instead of popping.
    let vis = 1;
    if (d.n) { vis = smooth(-0.35, 0.1, d.n[0] * vx + d.n[1] * vy + d.n[2] * vz); if (vis <= 0) continue; }
    const pe = p >= 1 ? 1 : 1 - (1 - p) * (1 - p);
    const q = project(d.fx + (d.x - d.fx) * pe, d.fy + (d.y - d.fy) * pe, d.fz + (d.z - d.fz) * pe, yaw);
    let a = vis * d.a * smooth(0, 0.6, p) * (0.65 + 0.35 * clamp((q[2] - 0.86) / 0.22, 0, 1)), r = d.r * q[2] * (0.6 + 0.4 * pe);
    if (d.out > 0 && !still) {             // only the outer foliage breathes
      a *= 1 - 0.35 * d.out * (0.5 + 0.5 * Math.sin(d.w3 * t + d.p3));
      r *= 1 + 0.2 * d.out * Math.sin(d.w4 * t + d.p4);
    }
    if (a < 0.02 || r < 0.2) continue;
    ctx.globalAlpha = a;
    ctx.beginPath(); ctx.arc(q[0], q[1], r, 0, 6.2832); ctx.fill();
  }
  ctx.globalAlpha = 1;
}